import { z } from 'zod/v3';
import { TopicSuggestionSchema } from "../topic-generation";

// Add Source Tool
export const AddSourceSchema = z.object({
  content: z.string().describe('the content or resource to add to the knowledge base'),
});

export type AddSource = z.infer<typeof AddSourceSchema>;

// Move Block Tool
export const MoveBlockSchema = z.object({
  blockId: z.string().describe("The ID of the block to move."),
  to: z.array(z.number()).describe("The path to move the block to (Plate/Slate Path)."),
  options: z.object({}).optional().describe('Optional parameters for the moveNodes operation'),
});

export type MoveBlock = z.infer<typeof MoveBlockSchema>;

// Edit TOC Tool
export const EditTocSchema = z.object({
  action: z.enum(['add', 'remove', 'update_title', 'reorder']).describe('The type of TOC modification.'),
  itemId: z.string().optional().describe('Identifier for the TOC item (e.g., blockId it points to).'),
  newTitle: z.string().optional().describe('New title for the TOC item (if updating).'),
  newOrder: z.array(z.string()).optional().describe('New order of TOC item IDs (if reordering).'),
  blockId: z.string().optional().describe('The block ID to link to if adding a new TOC item.'),
});

export type EditToc = z.infer<typeof EditTocSchema>; 

/**
 * Suggest a topic from the chat, which can add new content
 */
export const SuggestTopicToolSchema = TopicSuggestionSchema.extend({
  content: z.any().describe('The content to suggest a topic for.'),
})

export type SuggestTopic = z.infer<typeof SuggestTopicToolSchema>;